module.exports = __webpack_public_path__ + "img/FremontLofts-Bensh-004.64f68b7e.jpg";